import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Organization } from '../../models/organization.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-organization-card',
  standalone: true,
  imports: [
    MatCardModule
  ],
  templateUrl: './organization-card.component.html',
  styleUrl: './organization-card.component.css'
})
export class OrganizationCardComponent implements OnInit {

  @Input() organization: Organization = new Organization(0, '', '', '');

  constructor(
    public router: Router,
  ) {
  }

  ngOnInit(): void {
    console.log("init", this.organization)
  }

  getMachinesCount(organization: Organization) {

    if (organization.rekbots == undefined) {
      return 0;
    }

    return organization.rekbots.length;
  }
}

